<section class="contact">
    <h1 appBottomTransitionReveal>Contacto</h1>
    <hr />
    <p appFadeInReveal>
        Queremos invitarte a dar el primer paso hacia un bienestar emocional.
        Si necesitas orientación, apoyo o deseas resolver tus inquietudes, estamos aquí para ti.
        <br />
        No dudes en contactarnos o pedir una cita.
    </p>

    <div class="contact-info">
        <div class="item" appFadeInReveal>
            <img src="/icons/whatsapp.svg" alt="Teléfono" class="icon" />
            <div>
                <h3>Teléfono</h3>
                <a href="https://wa.link/227699" target="_blank">675 181 684</a>
            </div>
        </div>

        <div class="item" appFadeInReveal>
            <img src="/icons/email.svg" alt="Email" class="icon" />
            <div>
                <h3>Email</h3>
                <a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a>
            </div>
        </div>

        <div class="item" appFadeInReveal>
            <img src="/icons/instagram.svg" alt="Redes sociales" class="icon" />
            <div>
                <h3>Instagram</h3>
                <a href="https://instagram.com/psico.anapellon" target="_blank">@psico.anapellon</a>
            </div>
        </div>
    </div>
</section>

<section class="address">
    <h3 appFadeInReveal>Dirección</h3>
    <p class="address-text" appFadeInReveal>
        <img src="/icons/map_location.webp" alt="Mapa" class="icon" />
        Calle Rosalia de Castro 19, 1ºB, Santander, Cantabria.
    </p>

    @if (showMap) {
    <div class="map" appFadeInReveal>
        <div id="map" class="map-image map-frame"></div>

        <div class="map-info">
            <div class="map-info-header">
                <h4>Psicología Ana Pellón Mendoza</h4>
                <a href="https://www.google.com/maps/search/?api=1&query=Psicologia+Ana+Pellon+Mendoza&query_place_id=ChIJ94R70GpJSQ0RGa2VsYjtqEI"
                    target="_blank" rel="noopener">
                    Ver en Google Maps
                </a>
            </div>
            <p>
                C. Rosalía de Castro, 19<br />
                39011 Santander, Cantabria
            </p>
        </div>
    </div>
    }

    @if (!showMap) {
    <div class="nomap" appFadeInReveal>
        <div class="map-placeholder">
            <img src="/map-placeholder.webp" alt="Mapa no disponible sin cookies" width="100%" height="350"
                class="map-image" style="object-fit: cover;" />
            <div class="map-overlay">
                <p>
                    No se puede mostrar el mapa porque has rechazado las cookies necesarias.
                    <span (click)="reopenConsent()" (keyup.enter)="reopenConsent()" tabindex="0">
                        Cambiar mi decisión
                    </span>
                </p>
            </div>
        </div>
    </div>
    }
</section>

<section class="contact-form">
    <h3 appFadeInReveal>Escríbenos</h3>

    @switch (currentState) {
    @case (ComponentState.Form) {
    <form [formGroup]="contactForm" (ngSubmit)="submitForm()" appFadeInReveal>
        <div class="input_container"
            [ngClass]="{'error': contactForm.get('name')?.invalid && contactForm.get('name')?.touched}">
            <label for="name">Nombre *</label>
            <input id="name" type="text" formControlName="name" />
            @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
            <div class="input_error">Ingresa tu nombre.</div>
            }
        </div>

        <div class="input_container"
            [ngClass]="{'error': contactForm.get('email')?.invalid && contactForm.get('email')?.touched}">
            <label for="email">Correo electrónico *</label>
            <input id="email" type="email" formControlName="email" />
            @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
            <div class="input_error">Introduce un email válido.</div>
            }
        </div>

        <div class="input_container">
            <label for="phone">Teléfono (opcional)</label>
            <input id="phone" type="text" formControlName="phone" />
        </div>

        <div class="input_container"
            [ngClass]="{'error': contactForm.get('message')?.invalid && contactForm.get('message')?.touched}">
            <label for="message">Mensaje *</label>
            <textarea id="message" formControlName="message"></textarea>
            @if (contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
            <div class="input_error">Escribe tu mensaje.</div>
            }
        </div>

        <div class="input_container terms"
            [ngClass]="{'error': contactForm.get('terms')?.invalid && contactForm.get('terms')?.touched}">
            <input type="checkbox" id="terms" formControlName="terms" />
            <label for="terms">
                Acepto la <a routerLink="/politica-de-privacidad">política de privacidad</a>
            </label>
        </div>

        <button type="submit" class="form_button">Enviar</button>
    </form>
    }

    @case (ComponentState.Loading) {
    <div class="form_state">Enviando...</div>
    }

    @case (ComponentState.Success) {
    <div class="form_state success">
        ¡Gracias por tu mensaje!<br />
        Lo hemos recibido y nos pondremos en contacto contigo lo antes posible.
    </div>
    }

    @case (ComponentState.Error) {
    <div class="form_state error">
        Ha ocurrido un problema al enviar el mensaje.<br />
        Por favor, inténtalo de nuevo más tarde o escríbenos directamente a
        <a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a>.
    </div>
    }
    }
</section>